import React from 'react'
import { Link } from 'react-router-dom'
import CardUI from '../../../../widgets/layout/CardUI'
import BadgeUI from '../../../../widgets/output/BadgeUI'
import ButtonTinyUI from '../../../../widgets/action/ButtonTinyUI'
import IconButtonUI from '../../../../widgets/action/IconButtonUI'
import LRTableActionsUI from '../../../../widgets/layout/LRTableActionsUI'
import LRTableBodyUI from '../../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../../widgets/layout/LRTableRowUI'
import ExternalStatusModalSF from './ExternalStatusModalSF'
import InternalStatusModalSF from './InternalStatusModalSF'
import LoanRemarksUpdateModalSF from '../util/LoanRemarksUpdateModalSF'
import LinkWithSpinnerUI from '../../../../widgets/action/LinkWithSpinnerUI'
import CSEmailModalSF from './CSEmailModalSF'
import './ComplianceStatus.css'
import FileUploadModalSF from '../../../../widgets/form/FileUploadModalSF'
import CSInternalEmailModalSF from './CSInternalEmailModalSF'
import CPInternalEmailModalSF from './CPInternalEmailModalSF'
import CPEmailModalSF from './CPEmailModalSF'
import FileUploadWithFileNameModalSF from '../../../../widgets/form/FileUploadWithFileNameModalSF'
import CSInternalMonitoringEmailModalSF from './CSInternalMonitoringEmailModalSF'
import SpinnerUI from '../../../../widgets/output/SpinnerUI'
import MoveToCsModalSF from './MoveToCsModalSF'
import AddCustomDocModalSF from './AddCustomDocModalSF'
import SetCSDueDateModalSF from './SetCSDueDateModalSF'
import DuplicateComplianceModalSF from './DuplicateComplianceModalSF'
import { CS_FILE_CODES_WITH_DUE_DATE } from './ComplianceStatusSF'
import DirectorExternalStatusModalSF from './DirectorExternalStatusModalSF'
import AddDsraUpdateCsModalSF from './AddDsraUpdateCsModalSF'

const ComplianceStatusUI = ({ context, loan, compliance, fileUpload, fileUploadList, onRefreshClick,
  onReuploadClick, selectedFile, selectedUserId,
  updateRemarksMode,
  onUpdateRemarksClick, onDownloadClick, selectedRemarks,
  cpCsStatusUpdateMode, onCpCsStatusUpdateClick, onCpCsStatusCancelClick, selectedFileCode,
  objectId,
  onCancelRemarksClick, onCreateRemarksClick,
  remarksList, selectedRemarksId,
  onInternalStatusUpdateClick, onInternalStatusCancelClick, internalStatusUpdateMode,
  emailSendMode, onEmailSendClick, onEmailSendCancel,
  internalEmailSubmitted, onSendInternalEmailClick, onSendInternalEmailCancel,
  onMoveToCsClick, moveToCs, moveToCsMode, onMoveToCsCancelClick,
  complianceDocsUploadMode, onComplianceDocsUpload, onComplianceDocsUploadClick, onComplianceDocsUploadCancel,
  complianceDocs2UploadMode, onComplianceDocs2Upload, onComplianceDocs2UploadClick, onComplianceDocs2UploadCancel,
  onSendCPInternalEmailClick, onCPEmailSendClick, internalCPEmailSubmitted, onSendCPInternalEmailCancel,
  cpEmailSendMode, onCPEmailSendCancel, onDownloadPOCounterParty, downloadPOCounterPartyRequested, onInternalCSMonitoringEmailClick,
  csInternalMonitoringEmailSendMode, onInternalCSMonitoringEmailCancel,
  selectedFileName, onFileDeleteClick, deleteFileMode,
  addCustomDocMode, onAddCustomDocClick, onAddCustomDocCancel,
  addDsraCsMode, onAddDsraCsClick, onAddDsraCsCancel,
  // Set CS Due Date
  setDueDateMode, setDueDateFileCode, setDueDateFileTitle,
  onSetDueDateClick, onSetDueDateCancel,
  // Duplicate compliance docs
  duplicateMode, onDuplicateClick, onDuplicateCancel,
  directorStatusUpdateMode, directorStatusFileCode, directorStatusUserId,
  directorStatusDirectorName, directorStatusCurrentStatus,
  onDirectorStatusUpdateClick, onDirectorStatusUpdateCancel,
}) => {

  // -------------------------------------------------------------------------
  // CHILD LOAN — show a redirect banner instead of duplicating the doc list.
  // -------------------------------------------------------------------------
  if (loan.parentLoanId) {
    const complianceTab = compliance === 'cs' ? 'cs' : 'cp'
    const complianceLabel = compliance === 'cs' ? 'Condition Subsequent' : 'Condition Precedent'
    const parentLabel = loan.parentLoanName || loan.parentLRN || loan.parentLoanId

    return (
      <div className='c_cmpl'>
        <LRTableActionsUI location='top'
          left={
            <span className='g_flex_left g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <span className='g_m_left_100 g_large'><b>{complianceLabel}</b></span>
            </span>
          }
          right={<span />}
        />
        <CardUI className='g_m_top_100'>
          <div className='parent-loan-compliance-notice g_flex_v' style={{ padding: '20px', gap: '12px' }}>
            <div className='g_flex_h g_flex_left'>
              <span className='icon icon-info-circle g_m_right_50 g_muted' />
              <span>
                This tranche (<b>{loan.loanName || loan.loanRefNum}</b>) is a child of{' '}
                <b>{parentLabel}</b>. {complianceLabel} documents are managed on the parent loan —
                there is no need to upload them again here.
              </span>
            </div>
            <div>
              <a
                href={`/su/loans/${loan.parentLoanId}/compliance/${complianceTab}`}
                className='g_btn g_btn_primary_small'
              >
                Go to {complianceLabel} → {parentLabel}
              </a>
            </div>
          </div>
        </CardUI>
      </div>
    )
  }

  // -------------------------------------------------------------------------
  // ROOT / PARENT LOAN — normal full render
  // -------------------------------------------------------------------------
  return (
    <div className='c_cmpl'>
      <LRTableActionsUI location='top'
        left={
          <span className='g_flex_left g_flex_h'>
            <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
            <span className='g_m_left_100 g_large'><b>
              {compliance === 'ts' ? 'Cash Flow Projections' : compliance === 'cs' ? 'Condition Subsequent' : 'Condition Precedent'}
            </b></span>
          </span>
        }
        right={<span />}
      />

      {
        !fileUploadList &&
        <span>No documents yet</span>
      }

      {compliance === 'cs' && (
        <div className='compliance-actions-wrapper'>
          <div className='compliance-action-links'>
            <LinkWithSpinnerUI label='Send internal email' onClick={onSendInternalEmailClick} />
            <LinkWithSpinnerUI label='Send email to client' onClick={onEmailSendClick} />
            <LinkWithSpinnerUI label='Send internal monitoring email' onClick={onInternalCSMonitoringEmailClick} />
            <Link to={`/su/loans/${loan.loanId}/compliance`}>Compliance of the loan</Link>
            <Link to={`/su/messageApprovals`}>Message Approvals</Link>
          </div>
          <div className='compliance-info-text'>
            <span className='g_muted'>Zip file upload is supported</span>
          </div>
          <div className='g_m_top_100'>
            <ButtonTinyUI label='+ Add Custom CS' onClick={onAddCustomDocClick} />
          </div>
          <div className='g_m_top_50'>
            <ButtonTinyUI label='+ Add DSRA Update CS' onClick={onAddDsraCsClick} />
          </div>
          <div className='g_m_top_50'>
            <ButtonTinyUI label='Duplicate from loan' onClick={onDuplicateClick} />
          </div>
        </div>
      )
      }

      {compliance === 'cp' &&
        <div className='compliance-actions-wrapper'>
          <div className='compliance-action-links'>
            <LinkWithSpinnerUI label='Send internal email' onClick={onSendCPInternalEmailClick} />
            <LinkWithSpinnerUI label='Send email to client' onClick={onCPEmailSendClick} />
            <Link to={`/su/loans/${loan.loanId}/compliance`}>Compliance of the loan</Link>
            <Link to={`/su/messageApprovals`}>Message Approvals</Link>
          </div>
          <div className='compliance-info-text'>
            <span className='g_muted'>Zip file upload is supported</span>
          </div>
          <div className='g_m_top_100'>
            <ButtonTinyUI label='+ Add Custom CP' onClick={onAddCustomDocClick} />
          </div>
          <div className='g_m_top_50'>
            <ButtonTinyUI label='Duplicate from loan' onClick={onDuplicateClick} />
          </div>
        </div>
      }

      <CardUI className='g_m_top_100'>
        <LRTableBodyUI>
          {
            fileUploadList.map((file, i) =>
              <div key={i} id={`cp-row-${i + 1}`} className='compliance-row-wrapper'>
                <LRTableRowUI className='g_flex_top compliance-file-row'
                  left={
                    <div className='g_flex_h g_flex_left'>
                      <TopRowLeftUI context={context} loan={loan} file={file} fileUpload={fileUpload} i={i}
                        onReuploadClick={onReuploadClick} onDownloadClick={onDownloadClick}
                        onUpdateRemarksClick={onUpdateRemarksClick} onCreateRemarksClick={onCreateRemarksClick}
                        onCpCsStatusUpdateClick={onCpCsStatusUpdateClick}
                        onComplianceDocs2UploadClick={onComplianceDocs2UploadClick}
                        onComplianceDocs2UploadCancel={onComplianceDocs2UploadCancel}
                        complianceDocs2UploadMode={complianceDocs2UploadMode}
                        onComplianceDocs2Upload={onComplianceDocs2Upload}
                        objectCode='cs' remarksList={remarksList} objectId={objectId}
                        selectedFileCode={selectedFileCode} selectedUserId={selectedUserId}
                        onDownloadPOCounterParty={onDownloadPOCounterParty}
                        selectedFileName={selectedFileName} onFileDeleteClick={onFileDeleteClick}
                        deleteFileMode={deleteFileMode} onDirectorStatusUpdateClick={onDirectorStatusUpdateClick} />
                    </div>
                  }
                  right={
                    <div className='g_flex_v'>
                      <TopRowRightUI context={context} file={file} onReuploadClick={onReuploadClick}
                        onCpCsStatusUpdateClick={onCpCsStatusUpdateClick}
                        onComplianceDocsUploadClick={onComplianceDocsUploadClick} />
                      {
                        compliance === 'cp' && file.movable &&
                        <Link to='#' className='g_m_left_100 g_flex_right move-to-cs-link'
                          onClick={onMoveToCsClick}
                          data-row-id={file.fileCode}
                        >
                          Move to CS
                        </Link>
                      }
                    </div>
                  }
                />
                <LRTableRowUI className='g_flex_top'
                  left={
                    <div className='g_flex_h g_flex_left'>
                      <BotRowLeftUI loan={loan} file={file} compliance={compliance}
                        context={context}
                        onReuploadClick={onReuploadClick} onDownloadClick={onDownloadClick}
                        onUpdateRemarksClick={onUpdateRemarksClick} onCreateRemarksClick={onCreateRemarksClick}
                        objectCode='cs' remarksList={remarksList} objectId={objectId}
                        onInternalStatusUpdateClick={onInternalStatusUpdateClick}
                        onSetDueDateClick={onSetDueDateClick}
                      />
                    </div>
                  }
                  right={
                    <BotRowRightUI context={context} file={file} objectCode='cs'
                      onReuploadClick={onReuploadClick} className='g_flex_top'
                      onCpCsStatusUpdateClick={onCpCsStatusUpdateClick}
                    />
                  }
                />
              </div>
            )
          }
        </LRTableBodyUI>

        <CSEmailModalSF context={context} loan={loan} onRefreshClick={onRefreshClick}
          sendMode={emailSendMode} onCancelClick={onEmailSendCancel} />
        <CPEmailModalSF context={context} loan={loan} onRefreshClick={onRefreshClick}
          sendMode={cpEmailSendMode} onCancelClick={onCPEmailSendCancel} />
        <CSInternalEmailModalSF context={context} loan={loan} onRefreshClick={onRefreshClick}
          sendMode={internalEmailSubmitted} onCancelClick={onSendInternalEmailCancel} />
        <CPInternalEmailModalSF context={context} loan={loan} onRefreshClick={onRefreshClick}
          sendMode={internalCPEmailSubmitted} onCancelClick={onSendCPInternalEmailCancel} />
        <CSInternalMonitoringEmailModalSF context={context} loan={loan} onRefreshClick={onRefreshClick}
          sendMode={csInternalMonitoringEmailSendMode} onCancelClick={onInternalCSMonitoringEmailCancel} />
        <DirectorExternalStatusModalSF
          context={context}
          loan={loan}
          updateMode={directorStatusUpdateMode}
          selectedFileCode={directorStatusFileCode}
          selectedUserId={directorStatusUserId}
          selectedDirectorName={directorStatusDirectorName}
          selectedDirectorStatus={directorStatusCurrentStatus}
          onCancelClick={onDirectorStatusUpdateCancel}
          onRefreshClick={onRefreshClick}
        />
      </CardUI>

      <ExternalStatusModalSF
        context={context} loan={loan} selectedFileCode={selectedFileCode}
        onRefreshClick={onRefreshClick} onCancelClick={onCpCsStatusCancelClick}
        updateMode={cpCsStatusUpdateMode} compliance={compliance} />

      <InternalStatusModalSF
        context={context} loan={loan} selectedFileCode={selectedFileCode} selectedFile={selectedFile}
        onRefreshClick={onRefreshClick} onCancelClick={onInternalStatusCancelClick}
        updateMode={internalStatusUpdateMode} />

      <LoanRemarksUpdateModalSF context={context} loan={loan}
        updateMode={updateRemarksMode} onCancelClick={onCancelRemarksClick}
        onRefreshClick={onRefreshClick} selectedRemarks={selectedRemarks} selectedRemarksId={selectedRemarksId} />

      {
        selectedFileCode !== 'cp_other' && selectedFileCode !== 'cs_other' &&
        <FileUploadModalSF
          context={context}
          uploadMode={complianceDocsUploadMode}
          onCancelClick={onComplianceDocsUploadCancel}
          signedUrlApi={`/api/su/loans/${loan.loanId}/compliances/files/${selectedFileCode}/v2/fileUploadSignedUrl`}
          onUpload={onComplianceDocsUpload}
          multiple={true}
        />
      }

      <FileUploadModalSF
        context={context}
        uploadMode={complianceDocs2UploadMode}
        onCancelClick={onComplianceDocs2UploadCancel}
        signedUrlApi={`/api/su/loans/${loan.loanId}/compliances/users/${selectedUserId}/files/${selectedFileCode}/v2/fileUploadSignedUrl`}
        onUpload={onComplianceDocs2Upload}
      />

      {
        (selectedFileCode === 'cp_other' || selectedFileCode === 'cs_other') &&
        <FileUploadWithFileNameModalSF
          context={context}
          uploadMode={complianceDocsUploadMode}
          onCancelClick={onComplianceDocsUploadCancel}
          signedUrlApi={`/api/su/loans/${loan.loanId}/compliances/files/${selectedFileCode}/v2/fileUploadSignedUrl`}
          onUpload={onComplianceDocsUpload}
        />
      }

      <MoveToCsModalSF
        context={context}
        loan={loan}
        moveMode={moveToCsMode}
        onCancelClick={onMoveToCsCancelClick}
        selectedFileCode={selectedFileCode}
        onRefreshClick={onRefreshClick}
      />

      <AddCustomDocModalSF
        context={context}
        loan={loan}
        compliance={compliance}
        addMode={addCustomDocMode}
        onCancelClick={onAddCustomDocCancel}
        onRefreshClick={onRefreshClick}
      />
      <AddDsraUpdateCsModalSF
        context={context}
        loan={loan}
        addMode={addDsraCsMode}
        onCancelClick={onAddDsraCsCancel}
        onRefreshClick={onRefreshClick}
      />

      <SetCSDueDateModalSF
        context={context}
        loan={loan}
        setDueDateMode={setDueDateMode}
        selectedFileCode={setDueDateFileCode}
        selectedFileTitle={setDueDateFileTitle}
        onCancelClick={onSetDueDateCancel}
        onRefreshClick={onRefreshClick}
      />

      <DuplicateComplianceModalSF
        context={context}
        loan={loan}
        compliance={compliance}
        duplicateMode={duplicateMode}
        onCancelClick={onDuplicateCancel}
        onRefreshClick={onRefreshClick}
      />
    </div>
  )
}

// ---- Sub-components ----
const DSRA_RELEASE_PREFIX = 'dsra_release'

const isDsraRelatedCS = (file) =>
  !!file.fileCode && file.fileCode.startsWith(DSRA_RELEASE_PREFIX)

const TopRowLeftUI = ({ i, loan, file, fileUpload, onReuploadClick, onDownloadClick,
  objectCode, onCpCsStatusUpdateClick, onComplianceDocs2UploadClick, onDownloadPOCounterParty,
  selectedFileName, selectedFileCode, selectedUserId, onFileDeleteClick, deleteFileMode, onDirectorStatusUpdateClick }) =>
  <div className='g_flex_h g_flex_top'>
    <span className='file-number'>{i + 1}</span>
    <div className='g_flex_v g_m_left_100 file-details'>

      <div className='g_flex_h g_flex_left file-title-row'>
        <span className='file-title'>{file.fileTitle}</span>
        {isDsraRelatedCS(file) && (
          <span className='dsra-cs-badge g_m_left_50'>DSRA related CS</span>
        )}
        <span className='file-name'>{file.fileName}</span>
      </div>

      {/* Show uploaded file links for non-director files */}
      {file.directorUploadList.length === 0 && fileUpload &&
        fileUpload.filter(f => f.fileCode === file.fileCode).map((fc, i) =>
          fc.fileList.map((f, j) =>
            <span key={j} className='g_flex_h g_flex_left file-list-item'>
              <Link onClick={onDownloadClick} to='#'
                data-file-code={file.fileCode} data-file-group={objectCode} data-file-name={f}>
                {f}
              </Link>
              <span className='icon icon-trash-o file-delete-icon' onClick={onFileDeleteClick}
                data-code={file.fileCode} data-file-group={objectCode} data-file-name={f} />
              <SpinnerUI show={selectedFileCode === file.fileCode && selectedFileName === f && deleteFileMode} />
            </span>
          )
        )
      }

      {/* PO counter party project links */}
      {file.fileCode === 'po_counter_party' && loan.termSheet.projectList.map((project, i) =>
        <Link key={i} to='#' onClick={onDownloadPOCounterParty}
          data-project-id={project.projectId} className='project-link'>
          {project.projectName}
        </Link>
      )}

      {/* Director upload section */}
      {file.directorUploadList.length > 0 &&
        <div className='director-upload-section'>
          {file.directorUploadList.map((dir, j) =>
            <div key={j} className='director-item'>
              <span className='g_m_left_100'>
                <div className='g_flex_h director-row'>
                  <span className='director-name'>{dir.fullName}</span>
                  <div className='g_flex_right director-actions'>
                    {/* Show Upload link unless waived */}
                    {dir.status !== 'waived' &&
                      <Link to='#' className='g_m_left_50' onClick={onComplianceDocs2UploadClick}
                        data-code={file.fileCode} data-user-id={dir.userId}>
                        Upload
                      </Link>
                    }
                    <span className='g_m_left_50'><BadgeUI label={dir.status} /></span>
                    <span className="icon icon-pencil g_m_left_50 g_cursor_pointer g_muted"
                      onClick={onDirectorStatusUpdateClick}
                      data-code={file.fileCode}
                      data-user-id={dir.userId}
                      data-director-name={dir.fullName}
                      data-current-status={dir.status}
                    />
                  </div>
                </div>

                {/* Show uploaded files for this director */}
                {fileUpload && fileUpload
                  .filter(f => f.directorUploadList.length > 0)
                  .map((fc, i) =>
                    fc.directorUploadList
                      .filter(director => director.userId === dir.userId)
                      .map((director, j) =>
                        director.fileList.map((f, k) => (
                          <span key={k} className='g_flex_h g_flex_left file-list-item'>
                            <Link onClick={onDownloadClick} to='#'
                              data-file-code={file.fileCode}
                              data-file-group={objectCode}
                              data-file-name={f}
                              data-user-id={director.userId}>
                              {f}
                            </Link>
                            <span className='icon icon-trash-o file-delete-icon' onClick={onFileDeleteClick}
                              data-code={file.fileCode} data-file-group={objectCode}
                              data-file-name={f} data-user-id={director.userId} />
                            <SpinnerUI show={selectedUserId === director.userId
                              && selectedFileCode === file.fileCode
                              && selectedFileName === f
                              && deleteFileMode} />
                          </span>
                        ))
                      )
                  )
                }

                {/* Status messages */}
                {/* {dir.status === 'reviewed_and_requires_resubmission' && dir.reuploadMessage &&
                  <span className='g_muted status-message'>Resubmission reason: {dir.reuploadMessage}</span>
                } */}
                {dir.status === 'waived' && dir.waivedMessage &&
                  <span className='g_muted status-message'>Waived message: {dir.waivedMessage}</span>
                }
              </span>
            </div>
          )}
        </div>
      }
    </div>
  </div>

const TopRowRightUI = ({ file, onCpCsStatusUpdateClick, onComplianceDocsUploadClick }) =>
  <span className='g_flex_v g_flex_right file-actions'>
    {
      file.directorUploadList.length === 0 &&
      <div className='g_flex_h g_flex_right action-group'>
        {
          file.status !== 'waived' &&
          <Link to='#' className='upload-text-link' onClick={onComplianceDocsUploadClick} data-code={file.fileCode}>
            Upload
          </Link>
        }
        <span className='g_m_left_50'><BadgeUI label={file.status} /></span>
        {
          file.fileCode !== 'net_worth_certificate' &&
          <span className="icon icon-pencil g_m_left_50 g_cursor_pointer g_muted"
            onClick={onCpCsStatusUpdateClick} data-code={file.fileCode} />
        }
      </div>
    }
  </span>

const BotRowLeftUI = ({ loan, file, compliance, context, remarksList, onUpdateRemarksClick,
  onInternalStatusUpdateClick, onSetDueDateClick }) =>
  <table className='remarks g_m_left_100'>
    <tbody>
      {
        file.internalStatus === 'not_complied' && compliance === 'cp' && file.dueDate &&
        <tr>
          <td className='remark-label'>Due date:</td>
          <td className='remark-value'>{file.dueDateF1}</td>
        </tr>
      }
      {
        file.internalStatus === 'complied' && compliance === 'cp' && file.cureDate &&
        <tr>
          <td className='remark-label'>Cure date:</td>
          <td className='remark-value'>{file.cureDateF1}</td>
        </tr>
      }
      {
        file.status === 'reviewed_and_requires_resubmission' && file.reuploadMessage &&
        <tr>
          <td className='remark-label'>Resubmission reason:</td>
          <td className='remark-value g_muted'>{file.reuploadMessage}</td>
        </tr>
      }
      {compliance === 'cs' && (
        <>
          {/* Due date row — shows date if set, or "+ Set due date" link if not */}
          {CS_FILE_CODES_WITH_DUE_DATE.has(file.fileCode) && (
            <tr>
              <td className='remark-label'>Default due date:</td>
              <td className='remark-value'>
                {file.dueDate ? (
                  file.dueDateF1
                ) : (
                  context.permissions.includes('su_manage') && (
                    <Link
                      to='#'
                      className='set-due-date-link'
                      onClick={onSetDueDateClick}
                      data-file-code={file.fileCode}
                      data-file-title={file.fileTitle || file.fileCode}
                      style={{ fontSize: '12px', color: '#5c7cfa' }}
                    >
                      + Set due date
                    </Link>
                  )
                )}
              </td>
            </tr>
          )}

          {/* For non-special files, just show the date if it exists */}
          {!CS_FILE_CODES_WITH_DUE_DATE.has(file.fileCode) && file.dueDate && (
            <tr>
              <td className='remark-label'>Default due date:</td>
              <td className='remark-value'>{file.dueDateF1}</td>
            </tr>
          )}

          {/* Extended due date — always shows latest value when status is due_date_extended */}
          {file.nextDueDateF1 && (
            <tr>
              <td className='remark-label'>Extended due date:</td>
              <td className='remark-value' style={{ color: '#e67e22', fontWeight: 500 }}>
                {file.nextDueDateF1}
              </td>
            </tr>
          )}
          {file.extendedDueDateReason && (
            <tr>
              <td className='remark-label'>Extension reason:</td>
              <td className='remark-value g_muted'>{file.extendedDueDateReason}</td>
            </tr>
          )}
          {/* {
            file.status === 'reviewed_and_requires_resubmission' && file.reuploadMessage &&
            <tr>
              <td className='remark-label'>Resubmission reason:</td>
              <td className='remark-value g_muted'>{file.reuploadMessage}</td>
            </tr>
          } */}

          {file.alertsIntervalDays && (
            <tr>
              <td className='remark-label'>Alert interval days:</td>
              <td className='remark-value'>{file.alertsIntervalDays}</td>
            </tr>
          )}
        </>
      )}
      {
        remarksList && remarksList.filter(r => r.objectId === file.fileCode).filter(r => r.status).map((remarks, i) =>
          <React.Fragment key={i}>
            <tr>
              <td className='g_muted g_no_wrap_2 remark-date'>
                {remarks.remarksDateF}
                {remarks.status && <i className='g_m_left_50 remark-status'>{remarks.status}</i>}
              </td>
              <td className='remark-text'>
                <span className='g_muted'>
                  {remarks.remarks}
                  <span className="icon icon-pencil g_m_left_50 g_cursor_pointer g_ultra_muted"
                    onClick={onUpdateRemarksClick}
                    data-object-id={file.fileCode}
                    data-date={remarks.remarksDate}
                    data-remarks={remarks.remarks}
                    data-remarks-id={remarks.remarksId} />
                </span>
              </td>
            </tr>
          </React.Fragment>
        )
      }
    </tbody>
  </table>

const BotRowRightUI = () => <span />

export default ComplianceStatusUI